<template>
  <div class="dqyxfx-warp">
    <resize-container :tabShow="tabShow">
      <div class="left-content" v-show="tabShow" slot="left">
        <tab-tree :data="viewTreeData" @tabTreeDefault="tabTreeDefault" @tabTreeClick="tabTreeClick" @changeCompany="changeCompany"></tab-tree>
      </div>
      <div class="right-content ">
        <btn-show @show="tabShow = !tabShow" content="左边树"></btn-show>
        <div class="dn-content-bg zt">
          <time-search ref="timeSearch" :control="{data:timeData}" @timeControlClick="bindgetSearchElem">
          </time-search>
        </div>

        <div class="box-row zt">
          <div class="el-col-lg-4-8 dn-content-bg ">
            <div class="num ">综合能源(千克标煤)</div>
            <div class="num bgR">{{usages.integratedEnergy}}</div>
          </div>
          <div class="el-col-lg-4-8 dn-content-bg ">
            <div class="num ">总用电量(kWh)</div>
            <div class="num bgR">{{usages.powerEnergy}}</div>
          </div>
          <div class="el-col-lg-4-8 dn-content-bg ">
            <div class="num ">总用水量(m³)</div>
            <div class="num bgR">{{usages.waterEnergy}}</div>
          </div>
          <div class="el-col-lg-4-8 dn-content-bg ">
            <div class="num ">总用天然气量(m³)</div>
            <div class="num bgR">{{usages.gasEnergy}}</div>
          </div>
          <div class="el-col-lg-4-8 dn-content-bg ">
            <div class="num ">总面积(m²)</div>
            <div class="num bgB">{{usages.area}}</div>
          </div>
          <div class="el-col-lg-4-8 dn-content-bg ">
            <div class="num ">总人数(人)</div>
            <div class="num bgB">{{usages.totalNumber}}</div>
          </div>
        </div>

        <div class="bg-box box-magin dn-content-bg zt">
          <div style="display: flex;">
            <el-radio-group v-model="tabUnit">
              <el-radio-button label="value">面均单耗</el-radio-button>
              <el-radio-button label="output">人均单耗</el-radio-button>
            </el-radio-group>

            <div style="display: flex;flex: 1;flex-flow: row-reverse;">
              <div style="display: flex;align-items: center;margin-left: 10px;">
                <div style="width: 18px;height: 8px;background: #4e6be3;margin-right: 10px;"></div>行业
              </div>
              <div style="display: flex;align-items: center;">
                <div style="width: 18px;height: 8px;background: #f7ba2a;margin-right: 10px;"></div>地方
              </div>
            </div>
          </div>
          <div class="tab-con">
            <el-row :gutter="10">
              <el-col :span="6">
                <div class="chart-box dn-content-bg">
                  <div class="chart-content" id="pieChart"></div>
                  <div class="chart-unit">（千克标煤/{{tabUnit==="value"?'m²':'人'}}）</div>
                  <div class="chart-title zt">综合能源</div>
                  <div class="chart-foot">
                    <div class="chart-foot-item">
                      <div>{{showConsumptionTime}}</div>
                      <div class="chart-num" :class="showConsumption.integratedEnergy.energy=='-'?'equal':(showConsumption.integratedEnergy.energy>0?'big':(showConsumption.integratedEnergy.energy==0?'equal':'small'))">
                        {{showConsumption.integratedEnergy.energy}}</div>
                    </div>
                    <div class="chart-foot-item">
                      <div>环比趋势</div>
                      <div class="chart-num" :class="showConsumption.integratedEnergy.huanbi=='-'?'equal':(showConsumption.integratedEnergy.huanbi>0?'big':(showConsumption.integratedEnergy.huanbi==0?'equal':'small'))">
                        {{showConsumption.integratedEnergy.huanbi!='-'?showConsumption.integratedEnergy.huanbi+"%":"-"}}</div>
                    </div>

                    <div class="icon-content">
                      <i class="iconfont " :class="showConsumption.integratedEnergy.huanbi=='-'?'icon-dengyu equal':(showConsumption.integratedEnergy.huanbi>0?'icon-shangzhang big':(showConsumption.integratedEnergy.huanbi==0?'icon-dengyu equal':'icon-xiajiang small'))"></i>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="chart-box dn-content-bg">
                  <div class="chart-content" id="pieChart-2"></div>
                  <div class="chart-unit">（kWh/{{tabUnit==="value"?'m²':'人'}}）</div>
                  <div class="chart-title zt">电{{tabUnit==="value"?'面均':'人均'}}单耗</div>
                  <div class="chart-foot">
                    <div class="chart-foot-item">
                      <div>{{showConsumptionTime}}</div>
                      <div class="chart-num" :class="showConsumption.powerEnergy.energy=='-'?'equal':(showConsumption.powerEnergy.energy>0?'big':(showConsumption.powerEnergy.energy==0?'equal':'small'))">
                        {{showConsumption.powerEnergy.energy}}</div>
                    </div>
                    <div class="chart-foot-item">
                      <div>环比趋势</div>
                      <div class="chart-num" :class="showConsumption.powerEnergy.huanbi=='-'?'equal':(showConsumption.powerEnergy.huanbi>0?'big':(showConsumption.powerEnergy.huanbi==0?'equal':'small'))">
                        {{showConsumption.powerEnergy.huanbi!='-'?showConsumption.powerEnergy.huanbi+"%":"-"}}</div>
                    </div>
                    <div class="icon-content">
                      <i class="iconfont " :class="showConsumption.powerEnergy.huanbi=='-'?'icon-dengyu equal':(showConsumption.powerEnergy.huanbi>0?'icon-shangzhang big':(showConsumption.powerEnergy.huanbi==0?'icon-dengyu equal':'icon-xiajiang small'))"></i>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="chart-box dn-content-bg">
                  <div class="chart-content" id="pieChart-3"></div>
                  <div class="chart-unit">（m³/{{tabUnit==="value"?'m²':'人'}}）</div>
                  <div class="chart-title zt">水{{tabUnit==="value"?'面均':'人均'}}能耗</div>
                  <div class="chart-foot">
                    <div class="chart-foot-item">
                      <div>{{showConsumptionTime}}</div>
                      <div class="chart-num" :class="showConsumption.waterEnergy.energy=='-'?'equal':(showConsumption.waterEnergy.energy>0?'big':(showConsumption.waterEnergy.energy==0?'equal':'small'))">
                        {{showConsumption.waterEnergy.energy}}</div>
                    </div>

                    <div class="chart-foot-item">
                      <div>环比趋势</div>
                      <!-- <div
                                class="chart-num"
                                >{{showConsumption.waterEnergy.huanbi?showConsumption.waterEnergy.huanbi+"%":"-"}}</div> -->
                      <!-- <div class="chart-num" :class="showConsumption.waterEnergy.huanbi>0?'big':(showConsumption.waterEnergy.huanbi==0?'equal':'small')">{{showConsumption.waterEnergy.huanbi}}%</div> -->
                      <div class="chart-num" :class="showConsumption.waterEnergy.huanbi=='-'?'equal':(showConsumption.waterEnergy.huanbi>0?'big':(showConsumption.waterEnergy.huanbi==0?'equal':'small'))">
                        {{showConsumption.waterEnergy.huanbi!='-'?showConsumption.waterEnergy.huanbi+"%":"-"}}</div>
                    </div>

                    <div class="icon-content">
                      <!-- <img
                                v-if="showConsumption.waterEnergy.huanbi"
                                :src="showConsumption.waterEnergy.huanbi>0?newup:newdown"
                                />
                                <img v-else :src="newequal" /> -->
                      <!-- <i class="iconfont " :class="showConsumption.waterEnergy.huanbi>0?'icon-shangzhang big':(showConsumption.waterEnergy.huanbi==0?'icon-dengyu equal':'icon-xiajiang small')"></i> -->
                      <i class="iconfont " :class="showConsumption.waterEnergy.huanbi=='-'?'icon-dengyu equal':(showConsumption.waterEnergy.huanbi>0?'icon-shangzhang big':(showConsumption.waterEnergy.huanbi==0?'icon-dengyu equal':'icon-xiajiang small'))"></i>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="chart-box dn-content-bg">
                  <div class="chart-content" id="pieChart-4"></div>
                  <div class="chart-unit">（m³/{{tabUnit==="value"?'m²':'人'}}）</div>
                  <div class="chart-title zt">天然气{{tabUnit==="value"?'面均':'人均'}}能耗</div>
                  <div class="chart-foot">
                    <div class="chart-foot-item">
                      <div>{{showConsumptionTime}}</div>
                      <!-- <div
                                class="chart-num"
                                >{{showConsumption.steamEnergy.energy?showConsumption.steamEnergy.energy:"-"}}</div> -->
                      <!-- <div class="chart-num" :class="showConsumption.steamEnergy.energy>0?'big':(showConsumption.steamEnergy.energy==0?'equal':'small')">{{showConsumption.steamEnergy.energy}}</div> -->
                      <div class="chart-num" :class="showConsumption.gasEnergy.energy=='-'?'equal':(showConsumption.gasEnergy.energy>0?'big':(showConsumption.gasEnergy.energy==0?'equal':'small'))">
                        {{showConsumption.gasEnergy.energy}}</div>
                    </div>

                    <div class="chart-foot-item">
                      <div>环比趋势</div>
                      <div class="chart-num" :class="showConsumption.gasEnergy.huanbi=='-'?'equal':(showConsumption.gasEnergy.huanbi>0?'big':(showConsumption.gasEnergy.huanbi==0?'equal':'small'))">
                        {{showConsumption.gasEnergy.huanbi!='-'?showConsumption.gasEnergy.huanbi+"%":"-"}}</div>
                    </div>

                    <div class="icon-content">
                      <i class="iconfont " :class="showConsumption.gasEnergy.huanbi=='-'?'icon-dengyu equal':(showConsumption.gasEnergy.huanbi>0?'icon-shangzhang big':(showConsumption.gasEnergy.huanbi==0?'icon-dengyu equal':'icon-xiajiang small'))"></i>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="bg-box box-magin dn-content-bg zt">
          <div>
            <el-radio-group v-model="tabType">
              <el-radio-button label="integrated">综合能源</el-radio-button>
              <el-radio-button label="power">电</el-radio-button>
              <el-radio-button label="water">水</el-radio-button>
              <el-radio-button label="gas">天然气</el-radio-button>
            </el-radio-group>
          </div>
          <div class="tab-con">
            <el-row :gutter="10">
              <el-col :span="24">
                <div class="chart-box dn-content-bg">
                  <div class="chart-bar-title dn-title-bg">{{tabUnit==="value"?'面均':'人均'}}单耗趋势</div>
                  <div class="chart-bar-content" id="chartBar" v-resize="resize"></div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="bg-box box-magin dn-content-bg ">
          <nk-table id="table" :data="tableData" :noDataTitle="'该时间段暂无数据'" :columns="columns" :border="false" :rowselect="true">
          </nk-table>
        </div>
      </div>
    </resize-container>
  </div>
</template>
<script>
// import { DataType, TreeTab, NkLeftTree } from "_c/index.js";
import {
  findDataByParam
} from "@/utils/index.js";
import TimeSearch from "@/components/common/TimeSearch.vue";
import TabTree from "@/components/common/TabTree.vue";
import NkTable from "@/components/common/NkTable";
import * as utils from "@/utils/index.js";
import echarts from "echarts";
import { isNull, isUndefined } from "util";
import newup from "@/assets/image/yxfx/dqyxfx/icon-top.png";
import newdown from "@/assets/image/yxfx/dqyxfx/icon-bottom.png";
import newequal from "@/assets/image/yxfx/dqyxfx/equal.png";
import BtnShow from "@/components/common/BtnShow.vue";
import dateTool from "@/utils/dateTool";
import ResizeContainer from "@/components/common/resizeContainer.vue";
let allTimeData = [
  {
    type: "day",
    label: "日",
  },
  {
    type: "month",
    label: "月",
  },
  {
    type: "year",
    label: "年",
  }
];
export default {
  components: {
    TimeSearch,
    TabTree,
    NkTable,
    BtnShow,
    ResizeContainer
  },

  data () {
    return {
      tabShow: true,
      timeData: allTimeData,
      newup: newup,
      newdown: newdown,
      newequal: newequal,
      typeIndex: 0,
      leftTreeStaticData: [],
      leftTreeData: [],
      selectNode: [],
      defaultCheckedKeys: [],
      currentNodekey: "",
      elem: null,
      toTime: "toTime",
      alarnclass: "alarnclass",
      tabUnit: "value",
      tabType: "integrated",
      barChart: null,
      pieChart1: null,
      pieChart2: null,
      pieChart3: null,
      pieChart4: null,
      usages: {
        integratedEnergy: "",
        totalPosSteamQuantity: "",
        totalPosWaterQuantity: "",
        totalPosEnergyQuantity: "",
        area: '',
        totalNumber: '',

      },
      viewTreeData: [],
      /**
       * 面均
       */
      areaConsumptionTrend: {
        gasEnergy: {
          huanbi: "",
          energy: ""
        },
        waterEnergy: {
          huanbi: "",
          energy: ""
        },
        powerEnergy: {
          huanbi: "",
          energy: ""
        },
        integratedEnergy: {
          huanbi: "",
          energy: ""
        }
      },
      perCapitaConsumptionTrend: {
        gasEnergy: {
          huanbi: "",
          energy: ""
        },
        waterEnergy: {
          huanbi: "",
          energy: ""
        },
        powerEnergy: {
          huanbi: "",
          energy: ""
        },
        integratedEnergy: {
          huanbi: "",
          energy: ""
        }
      },
      showConsumption: {
        gasEnergy: {
          huanbi: "",
          energy: ""
        },
        waterEnergy: {
          huanbi: "",
          energy: ""
        },
        powerEnergy: {
          huanbi: "",
          energy: ""
        },
        integratedEnergy: {
          huanbi: "",
          energy: ""
        }
      },
      showConsumptionTime: "2020-06-12",
      //#产量单耗趋势
      productConsumptionTrend: {},
      perCapitaConsumption: {},
      maxMainValue: null,
      energyUsageTrend: null,
      tdpConsumptionTrend: null,//产值单耗
      areaConsumptionTrend: null,//面均单耗趋势
      areaConsumption: null,//面均单耗趋势
      perCapitaConsumptionTrend: null,//人均单耗趋势
      energyUsageTable: null,//表格数据
      columns: [],
      tableData: [],
      unit: '',
      tables: {},
      fa: {},/*  阈值线*/
      tables: {},
    };
  },
  created () {
  },
  mounted () {
    this.initPieChart();
    this.initBarChart("chartBar");
  },
  activated () {
  },
  watch: {
    tabUnit (val) {
      //修改图表的值
      this.setPieChartData(val);
      this.setEnergyData(this.tabType)
    },
    tabType (val) {
      this.setEnergyData(val);
    }
  },
  methods: {
    resize () {
      let vm = this;
      if (vm.barChart) {
        vm.barChart.resize();
      }
    },
    bindShowCheckBoxContent () {
      let vm = this;
      vm.showCheckBoxContent = !vm.showCheckBoxContent;
    },
    checkChange (e, index) {
      let vm = this;
    },
    clicksummit (type) {
      let vm = this;
      if (type == "sure") {
        let vm = this;
        let checkeds = vm.checkData.filter(obj => obj.checked == true);
        let codes = handleData.setCodes("power");
        codes = codes.concat(checkeds);
        vm.getMaxMin(codes);
        vm.getDqyxfxData(codes);
      } else {
        vm.checkData = JSON.parse(JSON.stringify(vm.checkDataTemp));
      }
      this.dialogFormVisible = false;
    },
    changeCompany (companyId) {
      let vm = this;
      vm.$api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(companyId, "/nygl/energyEfficiency", null)
        .then(res => {
          if (res) {
            vm.viewTreeData = findDataByParam("viewTree", true, res.data);
            // setTimeout(()=>{
            //     console.log(1111)

            // },10)
            // vm.bindgetSearchElem(vm.selectedDate);
          }
        });
    },
    clickoTherAdd () {
      this.checkDataTemp = JSON.parse(JSON.stringify(this.checkData));
      this.dialogFormVisible = true;
    },
    //树加载
    tabTreeDefault (node) {
      console.log(111111111111)
      let vm = this;
      vm.selectNodes = [node];
      let time = new Date();
      let startTime = dateTool.format(time, "yyyy-MM-dd") + " 00:00:00";
      time.setDate(time.getDate() + 1);
      let endTime = dateTool.format(new Date(time), "yyyy-MM-dd") + " 00:00:00";
      vm.selectedDate = {
        dataType: "1",
        dateType: "day",
        endTime: endTime,
        startTime: startTime,
      };
      console.log(22222)
      vm.bindgetSearchElem(vm.selectedDate);
    },
    tabTreeClick (e) {
      this.selectNodes = [e];
      this.bindgetSearchElem(this.selectedDate);
    },
    bindgetSearchElem (e) {
      this.selectedDate = e
      this.getData(this.selectNodes[0].measureId);
    },
    getData (id) {
      let vm = this;
      let dateType = this.selectedDate.dateType
      let startDate = this.selectedDate.startTime
      let endDate = this.selectedDate.endTime
      switch (dateType) {
        case "day":
          vm.showConsumptionTime = dateTool.format(
            new Date(startDate),
            "yyyy年MM月dd日"
          );
          dateType = 1;
          break;
        case "month":
          vm.showConsumptionTime = dateTool.format(
            new Date(startDate),
            "yyyy年MM月"
          );
          dateType = 2;
          break;
        case "year":
          vm.showConsumptionTime = dateTool.format(
            new Date(startDate),
            "yyyy年"
          );
          dateType = 3;
          break;
      }
      vm.$api.beadmin
        .getEnergyEfficiencyBenchmark(id, dateType, startDate, endDate, true)
        .then(res => {
          //
          vm.$api.beadmin
            .getBenchmarkKPI(id, dateType, startDate, endDate)
            .then(res2 => {
              if (res) {
                vm.usages = res.data.usages;
                vm.fa = res.data.fa;
                vm.tables = res.data.tables;
                vm.areaConsumptionTrend = res.data.areaConsumptionTrend;
                vm.areaConsumption = res.data.areaConsumption;
                vm.tables = res.data.tables;
                vm.perCapitaConsumptionTrend = res.data.perCapitaConsumptionTrend;
                vm.perCapitaConsumption = res.data.perCapitaConsumption;
                vm.productConsumptionTrend = res.data.productConsumptionTrend;
                vm.energyUsageTrend = res.data.energyUsageTrend;
                vm.tdpConsumptionTrend = res.data.tdpConsumptionTrend;
                vm.areaConsumptionTrend = res.data.areaConsumptionTrend;
                vm.perCapitaConsumptionTrend = res.data.perCapitaConsumptionTrend;
                vm.energyUsageTable = res.data.energyUsageTable;
                vm.setEnergyData(vm.tabType);
                let maxMainData = res2.data
                let maxMainValue = {
                  output: {
                    integrated: {
                      all: {
                        min: 0,
                        max: 1.5
                      },
                      local: {
                        min: 0,
                        max: 11
                      },
                      industry: {
                        min: 0,
                        max: 1
                      }
                    },
                    ele: {
                      all: {
                        min: 0,
                        max: 1
                      },
                      local: {
                        min: 0,
                        max: 1
                      },
                      industry: {
                        min: 0,
                        max: 1
                      }
                    },
                    water: {
                      all: {
                        min: 0,
                        max: 1
                      },
                      local: {
                        min: 0,
                        max: 1
                      },
                      industry: {
                        min: 0,
                        max: 1
                      }
                    },
                    gas: {
                      all: {
                        min: 0,
                        max: 1
                      },
                      local: {
                        min: 0,
                        max: 1
                      },
                      industry: {
                        min: 0,
                        max: 1
                      }
                    }
                  },
                  value: {
                    integrated: {
                      all: {
                        min: 0,
                        max: 1.0
                      },
                      local: {
                        min: 0,
                        max: 4
                      },
                      industry: {
                        min: 0,
                        max: 2
                      }
                    },
                    ele: {
                      all: {
                        min: 0,
                        max: 1
                      },
                      local: {
                        min: 0,
                        max: 1
                      },
                      industry: {
                        min: 0,
                        max: 1
                      }
                    },
                    water: {
                      all: {
                        min: 0,
                        max: 1
                      },
                      local: {
                        min: 0,
                        max: 1
                      },
                      industry: {
                        min: 0,
                        max: 1
                      }
                    },
                    gas: {
                      all: {
                        min: 0,
                        max: 1
                      },
                      local: {
                        min: 0,
                        max: 1
                      },
                      industry: {
                        min: 0,
                        max: 1
                      }
                    }
                  }
                };
                for (let index = 0; index < maxMainData.length; index++) {
                  const element = maxMainData[index];
                  let obj = {};
                  switch (element.name) {
                    case "integrated":
                      obj = vm.getMinMax(element.kpis);
                      maxMainValue.output.integrated = obj.output;
                      maxMainValue.value.integrated = obj.value;
                      break;
                    case "power":
                      obj = vm.getMinMax(element.kpis);
                      maxMainValue.output.ele = obj.output;
                      maxMainValue.value.ele = obj.value;
                      break;
                    case "water":
                      obj = vm.getMinMax(element.kpis);
                      maxMainValue.output.gas = obj.output;
                      maxMainValue.value.gas = obj.value;
                      break;
                    case "gas":
                      obj = vm.getMinMax(element.kpis);
                      maxMainValue.output.gas = obj.output;
                      maxMainValue.value.gas = obj.value;
                      break;
                  }
                }
                vm.maxMainValue = maxMainValue;
                vm.setPieChartData(vm.tabUnit);
              }
            });
        });
    },
    /**
     * 传入类型。类型为人均或面均
     */
    setPieChartData (type) {
      let vm = this;
      //   this.getData(this.selectNodes[0].measureId);
      let maxMainValue = vm.maxMainValue
      if (maxMainValue) {
        //最大最小。地方、行业的最大最小值
        let data = maxMainValue[type];
        let option1 = vm.pieChart1.getOption();
        let option2 = vm.pieChart2.getOption();
        let option3 = vm.pieChart3.getOption();
        let option4 = vm.pieChart4.getOption();
        if (type === "output") {
          vm.showConsumption = vm.perCapitaConsumption;
        } else {
          vm.showConsumption = vm.areaConsumption;
        }
        let obj = vm.showConsumption;
        vm.pieChart1.setOption(
          vm.setOption(
            data["integrated"],
            option1,
            obj.integratedEnergy.energy
          ),
          true
        );
        vm.pieChart2.setOption(
          vm.setOption(data["ele"], option2, obj.powerEnergy.energy),
          true
        );
        /* 暂时 */
        vm.pieChart3.setOption(
          vm.setOption(data["water"], option3, obj.waterEnergy.energy),
          true
        );
        vm.pieChart4.setOption(
          vm.setOption(data["gas"], option4, obj.gasEnergy.energy),
          true
        );
        /* 暂时 */
      }
    },
    getMinMax (kpis) {
      let obj = {
        output: {
          all: {
            min: 0,
            max: 1
          },
          local: {
            min: 0,
            max: 1
          },
          industry: {
            min: 0,
            max: 1
          }
        },
        value: {
          all: {
            min: 0,
            max: 1
          },
          local: {
            min: 0,
            max: 1
          },
          industry: {
            min: 0,
            max: 1
          }
        }
      };
      for (let j = 0; j < kpis.length; j++) {
        const item = kpis[j];
        switch (item.name) {
          case "perCapitaConsumption":  /* 地方 */
            obj.output.all.min = item.min;
            obj.output.all.max = item.max;
            break;
          case "perCapitaConsumption_Local": /* 行业 */
            obj.output.local.min = item.min;
            obj.output.local.max = item.max;
            break;
          case "perCapitaConsumption_Industry":
            obj.output.industry.min = item.min;
            obj.output.industry.max = item.max;
            break;
          case "areaConsumption":  /* 面均 */
            obj.value.all.min = item.min;
            obj.value.all.max = item.max;
            break;
          case "areaConsumption_Local":
            obj.value.local.min = item.min;
            obj.value.local.max = item.max;
            break;
          case "areaConsumption_Industry":
            obj.value.industry.min = item.min;
            obj.value.industry.max = item.max;
            break;
        }
      }
      return obj;
    },
    setOption (optionMinMaxData, option, value) {
      option.series[0].min = optionMinMaxData["all"].min;  /* 最大最小值 */
      option.series[0].max = optionMinMaxData["all"].max;
      option.series[2].min = optionMinMaxData["local"].min;  /* 本地最大最小值 */
      option.series[2].max = optionMinMaxData["local"].max;
      option.series[3].min = optionMinMaxData["industry"].min;  /* 行业最大最小值 */
      option.series[3].max = optionMinMaxData["industry"].max;
      option.series[4].min = optionMinMaxData["all"].min;
      option.series[4].max = optionMinMaxData["all"].max;
      option.series[2].axisLine.lineStyle.color = [
        [
          optionMinMaxData["local"].min / optionMinMaxData["all"].max,
          "#e6e6e6"
        ],
        [
          optionMinMaxData["local"].max / optionMinMaxData["all"].max,
          "#f7ba2a"
        ],
        [1, "#e6e6e6"]
      ];
      option.series[3].axisLine.lineStyle.color = [
        [
          optionMinMaxData["industry"].min / optionMinMaxData["all"].max,
          "#e6e6e6"
        ],
        [
          optionMinMaxData["industry"].max / optionMinMaxData["all"].max,
          "#4e6be3"
        ],
        [1, "#e6e6e6"]
      ];
      if (value) {
        option.series[4].data = [value];
      } else {
        option.series[4].data = [0];
      }
      return option;
    },
    setEnergyData (type) {
      let vm = this;
      const keys = {
        integrated: "integratedEnergy",
        power: "powerEnergy",
        water: "waterEnergy",
        gas: "gasEnergy",
      };
      /* 表格数据开始 */
      let tableData
      if (vm.tabUnit == 'value') {
        tableData = vm.tables.areaConsumptionTrend[keys[type]]
      } else {
        tableData = vm.tables.perCapitaConsumptionTrend[keys[type]]
      }
      let columns = [
        {
          prop: "type",
          label: "单耗趋势类型",
          show: true,
          width: 150,
          fixed: 'left',
          align: "center",
        },
        {
          prop: "energy",
          label: "能源类型",
          show: true,
          fixed: 'left',
          align: "center",
        },
      ]
      let data = {
        coulmns: ['1时', '2时', '3时'],
        values: [1, 2, 3]
      }
      let rows = {}
      let energy = null
      if (vm.tabType == 'integrated') {
        energy = '综合能源'
      } else if (vm.tabType == 'power') {
        energy = '电'
      } else if (vm.tabType == 'water') {
        energy = '水'
      } else {
        energy = '天然气'
      }
      rows = {}
      tableData[0].coulmns.forEach((temp, j) => {
        columns.push(
          {
            prop: temp,
            label: temp,
            show: true,
            align: "center",
          }
        )
        rows['type'] = vm.tabUnit === "value" ? '面均单耗趋势' : '人均单耗趋势'
        rows['energy'] = energy
        rows[temp] = tableData[1].values[j]
      })
      this.columns = columns
      vm.tableData = [rows]
      /* 表格数据结束 */
      vm.getUnit()
      let obj = vm.areaConsumptionTrend[0][keys[type]];
      if (vm.tabUnit == 'output') {
        obj = vm.perCapitaConsumptionTrend[0][keys[type]];
      }
      let xData = [];
      let yData = [];
      Object.keys(obj).forEach(key => {
        xData.push(key);
        yData.push(obj[key] === '-' ? '-' : parseFloat(obj[key]).toFixed(4));
      });
      let tabUnit = 'average';
      if (vm.tabUnit == 'value') {
        tabUnit = 'average';
      } else {
        tabUnit = 'perCapita';
      }
      //设置chart
      vm.barChart.setOption({
        xAxis: {
          data: xData
        },
        yAxis: {
          name: vm.unit
        },
        series: [
          {
            name: "耗能",
            type: "bar",
            barWidth: "80%",
            data: yData,
            markLine: {
              data: [{
                // yAxis: linevalue
                yAxis: vm.fa[tabUnit][vm.tabType]
              }],
              label: {
                normal: {
                  formatter: vm.fa[tabUnit][vm.tabType]        // 这儿设置安全基线
                  // formatter: energy+":"+vm.fa[vm.tabUnit][vm.tabType]        // 这儿设置安全基线
                }
              },
            },

          }
        ],
        toolbox: {
          show: true,
          feature: {
            magicType: {
              type: ['line', 'bar']
            } //切换为折线图，切换为柱状图
          }
        },
      });
    },
    /* 获取echarts单位 */
    getUnit () {
      let vm = this
      if (vm.tabUnit == 'value') {
        switch (vm.tabType) {
          case "integrated":
            vm.unit = "kgce/m²";
            break;
          case "power":
            vm.unit = "kWh/m²";
            break;
          case "water":
            vm.unit = "m³/m²";
            break;
          case "gas":
            vm.unit = "m³/m²";
            break;
        }
      } else {
        switch (vm.tabType) {
          case "integrated":
            vm.unit = "kgce/人";
            break;
          case "power":
            vm.unit = "kWh/人";
            break;
          case "water":
            vm.unit = "m³/人";
            break;
          case "gas":
            vm.unit = "m³/人";
            break;
        }
      }
    },
    initPieChart (id) {
      let vm = this;
      // 基于准备好的dom，初始化echarts实例
      vm.pieChart1 = echarts.init(document.getElementById("pieChart"));
      vm.pieChart2 = echarts.init(document.getElementById("pieChart-2"));
      vm.pieChart3 = echarts.init(document.getElementById("pieChart-3"));
      vm.pieChart4 = echarts.init(document.getElementById("pieChart-4"));
      let option = {
        backgroundColor: "#ffffff",
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {  /* 这层只是数字 */
            name: "最外圈数字刻度",
            type: "gauge",
            z: 2,
            radius: "160%",
            splitNumber: 5,
            startAngle: 180,
            endAngle: 0,
            min: 1,
            // min: 0,
            max: 100,
            center: ["50%", "90%"],
            axisLine: {
              // 坐标轴线
              lineStyle: {
                width: 25,
                opacity: 0 //刻度背景宽度
              }
            },
            splitLine: {
              show: false
            },
            data: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#988bbe",
                fontSize: 14
              },
              formatter: "{value}"
            },
            pointer: {
              show: false
            },
            axisTick: {
              show: false
            },
            detail: {
              show: 0
            }
          },
          {
            startAngle: 180, //开始角度 左侧角度   /* 这层是透明刻度 */
            endAngle: 0, //结束角度 右侧
            radius: "100%",
            // startAngle: 180, //开始角度 左侧角度
            // endAngle: 0, //结束角度 右侧
            // radius: "100%",
            // center: ["50%", "90%"],
            center: ["50%", "90%"],
            splitNumber: 5,
            type: "gauge",
            min: 0,
            max: 100,
            axisLine: {
              show: true,
              lineStyle: {
                width: 1,
                color: [[1, "rgba(0,0,0,0)"]]
              }
            },
            //刻度标签。
            axisTick: {
              show: true,
              splitNumber: 7,
              lineStyle: {
                color: "#4c647c",
                width: 1
              },
              length: -8
            }, //刻度样式
            splitLine: {
              show: true,
              length: -20,
              lineStyle: {
                color: "#4c647c"
              }
            }, //分隔线样式
            detail: {
              show: false
            },
            pointer: {
              show: false
            }
          },
          {
            type: "gauge",
            radius: "80%",
            name: "地方",
            startAngle: 180, //开始角度 左侧角度
            endAngle: 0, //结束角度 右侧
            center: ["50%", "90%"],
            splitNumber: 0, //刻度数量
            min: 0,
            max: 100,
            axisLine: {
              show: true,
              lineStyle: {
                width: 15,
                color: [
                  [0.3, "#e6e6e6"],
                  [0.6, "#f7ba2a"],
                  [1, "#e6e6e6"]
                ]
              }
            },
            //分隔线样式。
            splitLine: {
              show: false
            },
            axisLabel: {
              show: false
            },
            axisTick: {
              show: false
            },
            pointer: {
              show: false,
              length: "80%",
              width: 3
            },
            title: {
              show: false
            },
            //仪表盘详情，用于显示数据。
            detail: {
              show: false
            }
          },
          {
            type: "gauge",
            radius: "50%",
            name: "行业",
            startAngle: 180, //开始角度 左侧角度
            endAngle: 0, //结束角度 右侧
            center: ["50%", "90%"],
            splitNumber: 0, //刻度数量
            min: 0,
            max: 100,
            axisLine: {
              show: true,
              lineStyle: {
                width: 15,
                color: [
                  [0.1, "#e6e6e6"],
                  [0.6, "#4e6be3"],
                  [1, "#e6e6e6"]
                ]
              }
            },
            //分隔线样式。
            splitLine: {
              show: false
            },
            axisLabel: {
              show: false
            },
            axisTick: {
              show: false
            },
            pointer: {
              show: false,
              length: 60,
              width: 3
            },
            title: {
              show: true,
              offsetCenter: [20, "-26%"], // x, y，单位px
              textStyle: {
                color: "#4c647c",
                fontSize: 16
              }
            },
            //仪表盘详情，用于显示数据。
            detail: {
              show: false
            }
          },
          {
            type: "gauge",
            radius: 120,
            startAngle: 180, //开始角度 左侧角度
            endAngle: 0, //结束角度 右侧
            center: ["50%", "90%"],
            splitNumber: 0, //刻度数量
            min: 0,
            max: 100,
            axisLine: {
              show: false
            },
            //分隔线样式。
            splitLine: {
              show: false
            },
            axisLabel: {
              show: false
            },
            axisTick: {
              show: false
            },
            pointer: {
              show: true,
              length: "80%",
              width: 3
            },
            title: {
              show: true,
              offsetCenter: [20, "-26%"], // x, y，单位px
              textStyle: {
                color: "#4c647c",
                fontSize: 16
              }
            },
            //仪表盘详情，用于显示数据。
            detail: {
              show: true,
              offsetCenter: [0, 14],
              color: "#4c647c",
              formatter: function (params) {
                if (isNaN(params)) {
                  params = '-'
                }
                return params;
              },
              textStyle: {
                fontSize: 16
              }
            },
            data: [50]
          }
        ]
      };
      // 指定图表的配置项和数据
      vm.pieChart1.setOption(option);
      vm.pieChart2.setOption(option);
      vm.pieChart3.setOption(option);
      vm.pieChart4.setOption(option);
    },
    initBarChart (id) {
      let vm = this;
      // 基于准备好的dom，初始化echarts实例
      if (id == 'chartBar') {
        vm.barChart = echarts.init(document.getElementById(id));
      }
      let option = {
        color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          top: 40,
          bottom: "8%",
          //   containLabel: true  /* 容器是否包含x轴 */
        },
        xAxis: {
          type: "category",
          data: [],
          //   axisTick: {
          //     alignWithLabel: true
          //   }
        },
        // visualMap: {
        //     show: false,
        //     pieces: [
        //         {
        //         gt: 0,
        //         lte: 0.5,          //这儿设置基线上下颜色区分 基线下面为绿色
        //         // lte: linevalue,          //这儿设置基线上下颜色区分 基线下面为绿色
        //         color: '#03d6d6'
        //     }, {

        //         gt: 0.5,          //这儿设置基线上下颜色区分 基线上面为红色
        //         color: '#e91642'
        //     }]
        // },
        yAxis: [
          {
            type: "value"
          }
        ],
        series: [
          {
            name: "耗能",
            type: "bar",
            barWidth: "60%",
            data: []
          }
        ]
      };
      // 指定图表的配置项和数据

      if (id == 'chartBar') {
        vm.barChart.setOption(option);
      }
    }
  }
};
</script>
<style scoped>
.zt {
  color: #000;
}
.ulbox {
  display: flex;
  flex-wrap: wrap;
}
.ulbox > li {
  line-height: 30px;
  font-size: 18px;
  list-style: none;
  width: 50%;
}

.dqyxfx-warp {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 14px;
  box-sizing: border-box;
  overflow: hidden;
}
.left-content {
  height: 100%;
  min-width: 200px;
  margin-right: 14px;
}
.right-content {
  height: 100%;
  position: relative;
  overflow: auto;
  display: flex;
  flex-flow: column;
}
.top {
  line-height: 40px;
}
.top ul {
  overflow: hidden;
  list-style: none;
  padding: 0;
  margin: 0;
}
.top ul li {
  float: left;
  font-size: 16px;
  margin-right: 20px;
  line-height: 30px;
}
.top ul li:first-child {
  margin-left: 0px;
}
.red {
  color: #ed6a93;
}
.tab-pane {
  position: relative;
}
.check-box {
  position: absolute;
  top: 0px;
  right: 54px;
  width: 180px;
  height: 150px;
  z-index: 999;
  overflow: auto;
  box-shadow: 0px 0px 5px #bcbcbc;
}
.check-btn-img {
  position: absolute;
  right: 0px;
  top: 0px;
  padding: 6px;
  z-index: 999;
  border-radius: 4px;
  box-shadow: 0px 0px 5px #bcbcbc;
}
.check-btn {
  position: absolute;
  right: 10px;
  top: 4px;
  z-index: 999;
  cursor: pointer;
}
.check-box ul {
  width: 100%;
  list-style: none;

  margin: 0px;
  padding: 0px;
}
.check-box ul li {
  padding: 4px;
}

.top {
  line-height: 40px;
  background: #fff;
  border-radius: 4px;

  padding: 14px;
  box-sizing: content-box;
}

.box-magin {
  margin-top: 14px;
}
.bg-box {
  border-radius: 4px;
  padding: 14px;
  box-sizing: content-box;
  border: 1px solid #f3eded;
  text-align: left;
  color: #000;
}
.bg-box1 {
  border-radius: 4px;
  /* padding: 14px; */
  box-sizing: content-box;
  border: 1px solid #f3eded;
  height: 300px;
}
.box-row {
  margin-top: 14px;
  box-sizing: content-box;
  color: #000;
}
.bgR {
  background: #db3800;
}
.bgB {
  background: #3fbcf2;
}
.el-col-lg-4-8 {
  width: calc(16.66% - 20px);
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 4px;
  height: 80px;
  padding: 10px;
  display: flex;
  flex-flow: column;
  text-align: center;
  font-size: 14px;
}
.num {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  border-radius: 4px;
}
.tab-con {
  margin-top: 10px;
}
.chart-box {
  width: 100%;
  height: 300px;
  overflow: hidden;
  /* background: #fff; */
  display: flex;
  flex-flow: column;
  border-radius: 4px;
  border: 1px solid #f3eded;
}
.chart-content {
  width: 100%;
  height: 250px;
  margin: 0px auto;
  margin-top: -60px;
}
.chart-unit {
  font-size: 14px;
  text-align: center;
  color: #aaadf9;
}
.chart-title {
  text-align: center;
  font-weight: bold;
  padding: 6px 0px;
  color: #999999;
}
.chart-foot {
  border-top: 1px solid #f3eded;
  display: flex;
  flex: 1;
}
.chart-num {
  font-weight: bold;
}
.chart-foot-item {
  flex: 1;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}
.chart-foot-item div {
  flex: 1;
  display: flex;
  align-items: center;
}
.chart-bar-title {
  width: 100%;
  text-align: left;
  height: 30px;
  line-height: 30px;
  padding: 0px 10px;
  color: #fff;
}
.chart-bar-content {
  width: 100%;
  margin-top: 10px;
  height: 400px;
}
.icon-content {
  display: flex;
  align-items: center;
  padding-right: 10px;
}
.big {
  color: #bc635e;
}
.small {
  color: #7fad7d;
}
.equal {
  color: #ffe793;
}
</style>